<template>
  <div class="k_main">
    <searchC></searchC>
    <div class="content">
      <div class="topadcs">
        <img
          :src="kimg.tp"
          v-if="kimg.tp"
          title="世界知名焊接设备首选供应商"
          alt="世界知名焊接设备首选供应商"
        />
      </div>
      <div class="rightl">
        <div class="righttop"></div>

        <div class="plc">
          <span> 首页 &raquo; 产品中心 &raquo; {{ nid }} </span>
        </div>
        <div class="rightbot"></div>
        <div class="righttop"></div>
        <div class="pro_main">
          <dl class="pd_list_dl" v-for="item in list" :key="item.id">
            <dt>
              <router-link
                :to="{ name: 'pinfo', params: { id: item.id, nid: nid } }"
              >
                <img :src="item.img" />
              </router-link>
            </dt>
            <dd>
              <router-link
                :to="{ name: 'pinfo', params: { id: item.id, nid: nid } }"
                >{{ item.name }}</router-link
              >
              <br />
              <i>
                <router-link
                  :to="{ name: 'pinfo', params: { id: item.id, nid: nid } }"
                >
                  <img src="../../static/images/cp_icon1.gif" class="mar" />
                </router-link>
                <a
                  href="http://wpa.qq.com/msgrd?v=3&site=威遥焊接&menu=yes&uin=497254175"
                  target="_blank"
                  title="立即咨询"
                >
                  <img
                    src="../../static/images/cp_icon2.gif"
                    alt="立即咨询"
                    title="立即咨询"
                  />
                </a>
              </i>
            </dd>
          </dl>
          <div v-if="!list.length">没找找到相关产品~</div>
          <div class="clear"></div>
        </div>
        <div class="rightbot"></div>
        <div class="RandomNews">
          <h4 class="diysr">推荐资讯</h4>
          <div class="news_random">
            <ul>
              <li v-for="item in news" :key="item.id">
                <span class="fr">{{ item.create_time }}</span>
                <router-link
                  tag="a"
                  target="_blank"
                  :to="{ name: 'news', params: { id: item.id } }"
                  >{{ item.title }}</router-link
                >
              </li>

              <div class="clear"></div>
            </ul>
          </div>
        </div>
        <div class="rightbot"></div>
      </div>
      <div class="leftr">
        <div class="leib2">
          <div class="tit">
            <span>产品中心</span>
          </div>
          <div class="nr">
            <h4 sid="0001,0005">
              <router-link
                tag="a"
                :to="{ name: 'product', params: { id: 1, nid: 5 } }"
                >按产品类别分</router-link
              >
            </h4>
            <ul>
              <li v-for="item in lista" :key="item.id">
                <router-link
                  tag="a"
                  :to="{ name: 'product', params: { id: item.id } }"
                  >{{ item.mc }}</router-link
                >
              </li>
            </ul>
            <h4 sid="0001,0026">
              <router-link
                tag="a"
                :to="{ name: 'product', params: { id: 1, nid: 5 } }"
                >按应用行业分</router-link
              >
            </h4>
            <ul>
              <li v-for="item in listb" :key="item.id">
                <router-link
                  tag="a"
                  :to="{ name: 'product', params: { id: item.id } }"
                  >{{ item.mc }}</router-link
                >
              </li>
            </ul>
            <h4>
              <a href="#" title="焊接材料">焊接材料</a>
            </h4>
            <ul>
              <li v-for="item in listc" :key="item.id">
                <router-link
                  tag="a"
                  :to="{ name: 'product', params: { id: item.id } }"
                  >{{ item.mc }}</router-link
                >
              </li>
            </ul>
            <h4>
              <a href="#" title="焊接配件">焊接配件</a>
            </h4>
            <ul>
              <li v-for="item in listd" :key="item.id">
                <router-link
                  tag="a"
                  :to="{ name: 'product', params: { id: item.id } }"
                  >{{ item.mc }}</router-link
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="leftbot"></div>

        <div class="leib mt10" id="lefttuijian">
          <div class="tit">推荐产品</div>
          <div class="nr">
            <dl class="pd_t05_con_dl" v-for="item in hotlist" :key="item.id">
              <dt>
                <router-link
                  :to="{ name: 'pinfo', params: { id: item.id, nid: 5 } }"
                >
                  <img :src="item.img" />
                </router-link>
              </dt>
              <dd>
                <router-link
                  :to="{ name: 'pinfo', params: { id: item.id, nid: 5 } }"
                  >{{ item.name }}</router-link
                >
              </dd>
            </dl>

            <div class="clear"></div>
          </div>
        </div>
        <div class="leftbot"></div>
        <div class="leib3 mt10">
          <div class="tit">联系方式</div>
          <div class="nr">
            <div class="dianhua">
              销售热线：
              <br />
              <span>021-65056515</span>
            </div>
            <div class="dianhua">
              售后热线：
              <br />
              <span>18616336851</span>
            </div>
            <p><span>公司电话：</span>021-65056515</p>
            <p><span>公司传真：</span>021-65053165</p>
            <p><span>公司邮箱：</span>18616336851@163.com</p>
            <p>
              <span>公司地址：</span>
              上海市杨浦区军工路100号20栋
            </p>
            <p>
              <span>工厂地址：</span>
              江苏省昆山市周市镇民管路25号1号楼2楼
            </p>
          </div>
          <div class="leftbot"></div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import { postPlist } from "@/utils/api"; //引入api至当前文件
import searchC from "@/views/search";
export default {
  name: "searchinfo",
  data() {
    return {
      kimg: "",
      list: [],
      lista: [],
      listb: [],
      listc: [],
      listd: [],
      hotlist: [],
      news: [],
      nid: "",
    };
  },
  components: {
    searchC,
  },
  mounted() {
    this.intPage();
  },
  watch: {
    $route(to, from) {
      this.intPage();
    },
  },
  methods: {
    intPage() {
      let id = this.$route.query.sval
        ? this.$route.query.sval
        : "请输入关键字~";
      this.nid = id;
      let data = {};
      data.val = id;
      postPlist(data).then((res) => {
        this.kimg = res.imgs;
        this.list = res.list;
        this.hotlist = res.hotlist;
        this.news = res.news;
        this.lista = res.catlist.filter((item) => {
          return item.dlid == 1;
        });
        this.listb = res.catlist.filter((item) => {
          return item.dlid == 3;
        });
        this.listc = res.catlist.filter((item) => {
          return item.dlid == 4;
        });
        this.listd = res.catlist.filter((item) => {
          return item.dlid == 5;
        });
      });
    },
  },
};
</script>

<style scoped>
</style>
